import React from 'react'
import { useLocation } from 'react-router-dom';
import { Font, PDFViewer, pdf, Document, Text, Page, Image, View, StyleSheet } from '@react-pdf/renderer'
import FirstPage from './FirstPage'
import PhysicalGrowthPage from './PhysicalGrowthPage'
import DevMilestonePage from './DevMilestonePage'
import NutritionalPage from './NutritionalPage'
import NutritionalSupplementalPage from './NutritionalSupplementPage';
import SocialPage from './SocialPage'
import EmotionalPage from './EmotionalPage'
import EmotionalSupplementPage from './EmotionalSupplementPage'
import OralRiskPage from './OralRiskPage'
import VaccinationPage from './VaccinationPage'
import VaccinationSupplementPage from './VaccinationSupplementPage'
import SummaryPage from './SummaryPage'
import fonts from '../../../config/fonts';
import reportStyles from './PDFReportStyles';       

// Register asynchronously loaded fonts before rendering anything.
// fonts.map((font) => Font.register({ family: font.name, src: font.url }))

const CompleteWellnessReport = () => {
    const { state } = useLocation();
    const entity = state.entity;
    const reportParams = state.reportParams;

 //Report Params
 console.log(reportParams.agerange);
 let ageRangeDesc = '6 years and above';
 if (reportParams.agerange === '1') {
     ageRangeDesc = '2 years';
 } else if (reportParams.agerange === '2') {
     ageRangeDesc = '3 to 5 years';
 }

    return (
        <div style={reportStyles.MainBGDivNoAlign}>
            <PDFViewer style={{ flex: 1, width:'95vh', minWidth:'95vh', height:'95vh' }}>
                <Document
                    author="ChildrenDoc LLC"
                    keywords="Children, Wellness"
                    subject="ChildrenDoc wellness report"
                    title="ChildrenDoc Online Wellbeing Scan Report"
                >



            


                    <FirstPage entity={entity} params={reportParams} key={entity.id}/>       
                    <PhysicalGrowthPage entity={entity} params={reportParams} key={entity.id}/>                
                    <DevMilestonePage entity={entity} params={reportParams} key={entity.id}/>       
                    <NutritionalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <NutritionalSupplementalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <SocialPage entity={entity} params={reportParams} key={entity.id}/>                
                    <EmotionalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <EmotionalSupplementPage entity={entity} params={reportParams} key={entity.id}/>                
                    <OralRiskPage entity={entity} params={reportParams} key={entity.id}/>                
                    <VaccinationPage entity={entity} params={reportParams} key={entity.id}/>                
                    <VaccinationSupplementPage entity={entity} params={reportParams} key={entity.id}/>                
                    <SummaryPage entity={entity} params={reportParams} key={entity.id}/>                           


                </Document>
            </PDFViewer>
        </div>
    )        
}
  
export default CompleteWellnessReport